import { jsx as _jsx } from "react/jsx-runtime";
import { PrivateMediaPlayer } from 'components/privateMediaPlayer';
export const StoryVideo = ({ attachment: { url: src, pretty_name }, type, onError, }) => {
    return (_jsx(PrivateMediaPlayer, { controls: { download: false }, mediaFile: { src, type }, filename: pretty_name, onError: onError }));
};
